import * as React from 'react';
import { Sector } from '../../Model/Sector';
import { Trans } from '../Trans';
import { AbstractModelSelectBox } from './AbstractModelSelectBox';

export class SectorSelectBox extends AbstractModelSelectBox<Sector> {
    protected getOptionProperty(): string {
        return 'sector';
    }

    protected renderLabel() {
        return <>
            <span className="sr-only"><Trans>Branche</Trans></span>
            <i className="fas fa-industry"/>
            {this.props.children}
        </>;
    }
}
